import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import {
	ForgetPasswordPayload,
	ForgetPasswordResponse,
	VerifyOtpResponse,
	VerifyOtpPayload,
	ResetPasswordPayload,
	ResetPasswordResponse,
} from '../models/reset-password';

export const forgetPassword = async (data: ForgetPasswordPayload) => {
	try {
		const response = await axios.post<JsonResponse<ForgetPasswordResponse>>('password/forget', data);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const verifyOtp = async (data: VerifyOtpPayload) => {
	try {
		const response = await axios.post<JsonResponse<VerifyOtpResponse>>('password/verify-otp', data);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const resetPassword = async (data: ResetPasswordPayload) => {
	try {
		const response = await axios.put<JsonResponse<ResetPasswordResponse>>('password/reset', data);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
